import { getSpecialGameDataByType } from '@Core/SpecialGames/SpecialGamesHelper';
import { gameInstance } from '@Game/GameComponent';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { ILockAndRoll } from '@GFTypes/GameStoreTypes';
import { ILockAndRollSymbolData, ISpinOutcome } from '@GFTypes/GameStoreTypes/SpinOutcome';
import { IAuthenticateResponseData } from '@GFTypes/Responses/AuthenticateResponse';
import { ESpecialGamesType } from '@GFTypes/SpecialGames';
import { getNormalizedLockAndRollCoinPositions } from '../Utils/SymbolIndexNormalizerUtils';

export const processLockAndRollAuthData = (data: IAuthenticateResponseData['outcome']): Partial<ILockAndRoll> | undefined => {
    if (!data.gameConfig.lockAndRollConfig) return undefined;
    const clone = structuredClone(data.gameConfig.lockAndRollConfig);

    const { multiplierWeights, staticJackpots, spinningSets } = clone;

    const lockAndRoll: Partial<ILockAndRoll> = { multiplierWeights, staticJackpots, spinningSets };

    return lockAndRoll;
};

export const processLockAndRollSpinData = (data: ISpinOutcome): Partial<ILockAndRoll> | undefined => {
    const clone = structuredClone(data);
    const lockAndRollResponseData = getSpecialGameDataByType(clone.specialGames, ESpecialGamesType.LOCK_AND_ROLL);

    if (!lockAndRollResponseData) return undefined;

    const numberOfSymbolsPerReel = gameInstance.gameStore.get(EGameStoreKeys.NumberOfSymbolsPerReel);
    const { triggerPositions, totalSpins, totalWin, currentSpin, lockAndRollData } = lockAndRollResponseData;

    if (!lockAndRollData?.symbols) return undefined;

    const normalizedPositions = getNormalizedLockAndRollCoinPositions(lockAndRollData.symbols, numberOfSymbolsPerReel);
    const symbols = lockAndRollData.symbols.map((symbol: ILockAndRollSymbolData, index: number) => {
        symbol.index = normalizedPositions[index][1];
        return symbol;
    });

    const lockAndRoll: Partial<ILockAndRoll> = { totalSpins, triggerPositions, totalWin, currentSpin, symbols };

    return lockAndRoll;
};
